import { render } from "./ArtirclListView.vue?vue&type=template&id=19eb29f4&scoped=true"
import script from "./ArtirclListView.vue?vue&type=script&lang=js"
export * from "./ArtirclListView.vue?vue&type=script&lang=js"

import "./ArtirclListView.vue?vue&type=style&index=0&id=19eb29f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19eb29f4"]])

export default __exports__